import styled from "@emotion/styled";
import {
  Avatar as MuiAvatar,
  Breadcrumbs as MuiBreadcrumbs,
  Button as MuiButton,
  Card as MuiCard,
  Chip as MuiChip,
  Divider as MuiDivider,
  Grid as MuiGrid,
  LinearProgress as MuiLinearProgress,
  Typography as MuiTypography,
  Paper as MuiPaper,
  ListItemButton as MuiListItemButton,
} from "@mui/material";
import { spacing } from "@mui/system";

export const Paper = styled(MuiPaper)(spacing);

export const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

export const Button = styled(MuiButton)(spacing);

export const Card = styled(MuiCard)(spacing);

export const Chip = styled(MuiChip)(spacing);

export const Divider = styled(MuiDivider)(spacing);

export const Grid = styled(MuiGrid)(spacing);

export const LinearProgress = styled(MuiLinearProgress)(spacing);

export const Spacer = styled.div(spacing);

export const Typography = styled(MuiTypography)(spacing);

export const SidebarWrapper = styled(Card)`
  height: 100%;
  min-height: calc(100vh - 250px);
  ${spacing}
`;

export const StyledListItemButton = styled(MuiListItemButton)`
  border-left: ${(props) =>
    props.active
      ? `4px solid ${props.theme.palette.primary.main}`
      : "4px solid transparent"};
  background-color: ${(props) =>
    props.active ? props.theme.palette.action.selected : "transparent"};
  &:hover {
    background-color: ${(props) => props.theme.palette.action.hover};
  }
`;

export const AboutIcon = styled.span`
  display: flex;
  padding-right: ${(props) => props.theme.spacing(2)};

  svg {
    width: 18px;
    height: 18px;
  }
`;
